const DEFAULT_TITLE = 'VRP CRM';

const TITLE_RULES = [
  { pattern: /^\/$/, title: 'VRP CRM' },
  { pattern: /^\/areas\/?$/, title: 'VRP - Selector principal' },
  { pattern: /^\/areas\/gestion\/usuarios/, title: 'VRP - Gestión de usuarios' },
  { pattern: /^\/areas\/gestion\/telefonos/, title: 'VRP - Contactos' },
  { pattern: /^\/areas\/gestion(?:\/)?$/, title: 'VRP - Selector gestión' },
  { pattern: /^\/areas\/plan-estrategico(?:\/|$)/, title: 'VRP - Plan estratégico' },
  { pattern: /^\/areas\/presupuestos/, title: 'VRP - Gestion de Presupuestos' },
  { pattern: /^\/areas\/gestor/, title: 'VRP - Selector gestor PR' },
  { pattern: /^\/areas\/iberdrola/, title: 'VRP - Selector Iberdrola' },
  { pattern: /^\/areas\/agenda/, title: 'VRP - Agenda' },
  { pattern: /^\/areas\/mantenimientos-periodicos/, title: 'VRP - Revisiones periódicas' },
  { pattern: /^\/areas\/instrumentacion/, title: 'VRP - Instrumentación' },
  { pattern: /^\/areas\/informes/, title: 'VRP - Informes' },
  { pattern: /^\/operarios(?:\/|$)/, title: 'VRP - Operarios' },
  { pattern: /^\/notificaciones/, title: 'VRP - Centro de notificaciones' },
  { pattern: /^\/produccion/, title: 'VRP - Producción' },
  { pattern: /^\/contabilidad/, title: 'VRP - Contabilidad' },
  { pattern: /^\/familias\//, title: 'VRP - Gestión de obras' },
  { pattern: /^\/v\//, title: 'VRP - Área comercial' },
  { pattern: /^\/dashboard\/clientes/, title: 'VRP - Dashboard de clientes' },
  { pattern: /^\/dashboard\/ventas/, title: 'VRP - Dashboard de ventas' },
  { pattern: /^\/document-suite(?:\/|$)/, title: 'VRP - Suite documental' },
  { pattern: /^\/suite-documental(?:\/|$)/, title: 'VRP - Suite documental' },
  { pattern: /^\/dashboard/, title: 'VRP - Dashboard' },
  { pattern: /^\/login/, title: 'VRP - Acceso' }
];

export function resolveDocumentTitle(pathname) {
  if (!pathname) return DEFAULT_TITLE;
  const match = TITLE_RULES.find((rule) => rule.pattern.test(pathname));
  return match ? match.title : DEFAULT_TITLE;
}
